// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.8.0",
  date: "2026-09-04T08:06:21.998Z",
  gitInfo: {
    dirty: false,
    raw: "58e4ff995",
    hash: "58e4ff995",
    distance: null,
    tag: null,
    semver: null,
    suffix: "58e4ff995",
    semverString: null
  }
};
/* tslint:enable */
